/* eslint-disable */
/**
 * AUTO-GENERATED by scripts/gen-uwm-typed-catalog.cjs — DO NOT EDIT BY HAND.
 *
 * One LoanFieldDescriptor per documented UWM Insights API Loans field. Used
 * by the workflow builder palette so super-administrators (and any author
 * once a field is opted in via the UWM Fields admin page) can drag any of
 * the 220 documented UWM fields onto a condition row.
 *
 * Paths target the `uwm.<FieldName>` namespace, which the worker's
 * `buildEvalContext` populates by parsing `loan.rawPayloadJson`. This means
 * EVERY actively-pulled UWM field is queryable in workflow predicates even
 * when no dedicated Loan column exists.
 */
import type { LoanFieldDescriptor } from './loan-fields.js';

export const UWM_RAW_FIELD_CATALOG: readonly LoanFieldDescriptor[] = [
  {
    id: 'uwm_AdjustedOriginationCharges',
    path: 'uwm.AdjustedOriginationCharges',
    sourceUwmField: 'AdjustedOriginationCharges',
    source: 'uwm',
    label: 'UWM · Adjusted Origination Charges',
    description: 'UWM Insights API field AdjustedOriginationCharges (Decimal). Read straight from the raw UWM payload.',
    type: 'number',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_AMCAppraisalCompletedDate',
    path: 'uwm.AMCAppraisalCompletedDate',
    sourceUwmField: 'AMCAppraisalCompletedDate',
    source: 'uwm',
    label: 'UWM · AMC Appraisal Completed Date',
    description: 'UWM Insights API field AMCAppraisalCompletedDate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_ApplicationOutDatetime',
    path: 'uwm.ApplicationOutDatetime',
    sourceUwmField: 'ApplicationOutDatetime',
    source: 'uwm',
    label: 'UWM · Application Out Datetime',
    description: 'UWM Insights API field ApplicationOutDatetime (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_AppraisalCompletedDate',
    path: 'uwm.AppraisalCompletedDate',
    sourceUwmField: 'AppraisalCompletedDate',
    source: 'uwm',
    label: 'UWM · Appraisal Completed Date',
    description: 'UWM Insights API field AppraisalCompletedDate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_AppraisalDueToUWMDate',
    path: 'uwm.AppraisalDueToUWMDate',
    sourceUwmField: 'AppraisalDueToUWMDate',
    source: 'uwm',
    label: 'UWM · Appraisal Due To UWM Date',
    description: 'UWM Insights API field AppraisalDueToUWMDate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'parties',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_AppraisalExpirationDate',
    path: 'uwm.AppraisalExpirationDate',
    sourceUwmField: 'AppraisalExpirationDate',
    source: 'uwm',
    label: 'UWM · Appraisal Expiration Date',
    description: 'UWM Insights API field AppraisalExpirationDate (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_AppraisalFee',
    path: 'uwm.AppraisalFee',
    sourceUwmField: 'AppraisalFee',
    source: 'uwm',
    label: 'UWM · Appraisal Fee',
    description: 'UWM Insights API field AppraisalFee (Integer). Read straight from the raw UWM payload.',
    type: 'integer',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_AppraisalOrderedDate',
    path: 'uwm.AppraisalOrderedDate',
    sourceUwmField: 'AppraisalOrderedDate',
    source: 'uwm',
    label: 'UWM · Appraisal Ordered Date',
    description: 'UWM Insights API field AppraisalOrderedDate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'dates',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_AppraisalOrderedFlag',
    path: 'uwm.AppraisalOrderedFlag',
    sourceUwmField: 'AppraisalOrderedFlag',
    source: 'uwm',
    label: 'UWM · Appraisal Ordered Flag',
    description: 'UWM Insights API field AppraisalOrderedFlag (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_AppraisalReceivedDate',
    path: 'uwm.AppraisalReceivedDate',
    sourceUwmField: 'AppraisalReceivedDate',
    source: 'uwm',
    label: 'UWM · Appraisal Received Date',
    description: 'UWM Insights API field AppraisalReceivedDate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'dates',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_AppraisalReceivedFlag',
    path: 'uwm.AppraisalReceivedFlag',
    sourceUwmField: 'AppraisalReceivedFlag',
    source: 'uwm',
    label: 'UWM · Appraisal Received Flag',
    description: 'UWM Insights API field AppraisalReceivedFlag (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_AppraisalReimbursement',
    path: 'uwm.AppraisalReimbursement',
    sourceUwmField: 'AppraisalReimbursement',
    source: 'uwm',
    label: 'UWM · Appraisal Reimbursement',
    description: 'UWM Insights API field AppraisalReimbursement (Decimal). Read straight from the raw UWM payload.',
    type: 'number',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_AppraisalWaiver',
    path: 'uwm.AppraisalWaiver',
    sourceUwmField: 'AppraisalWaiver',
    source: 'uwm',
    label: 'UWM · Appraisal Waiver',
    description: 'UWM Insights API field AppraisalWaiver (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_AppraisedValue',
    path: 'uwm.AppraisedValue',
    sourceUwmField: 'AppraisedValue',
    source: 'uwm',
    label: 'UWM · Appraised Value',
    description: 'UWM Insights API field AppraisedValue (Integer). Read straight from the raw UWM payload.',
    type: 'integer',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_ApprovalExpiration',
    path: 'uwm.ApprovalExpiration',
    sourceUwmField: 'ApprovalExpiration',
    source: 'uwm',
    label: 'UWM · Approval Expiration',
    description: 'UWM Insights API field ApprovalExpiration (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_AssetExpirationDate',
    path: 'uwm.AssetExpirationDate',
    sourceUwmField: 'AssetExpirationDate',
    source: 'uwm',
    label: 'UWM · Asset Expiration Date',
    description: 'UWM Insights API field AssetExpirationDate (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'dates',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_AUS',
    path: 'uwm.AUS',
    sourceUwmField: 'AUS',
    source: 'uwm',
    label: 'UWM · AUS',
    description: 'UWM Insights API field AUS (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_AWCDateTime',
    path: 'uwm.AWCDateTime',
    sourceUwmField: 'AWCDateTime',
    source: 'uwm',
    label: 'UWM · Awc Date Time',
    description: 'UWM Insights API field AWCDateTime (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_BaseLoanAmount',
    path: 'uwm.BaseLoanAmount',
    sourceUwmField: 'BaseLoanAmount',
    source: 'uwm',
    label: 'UWM · Base Loan Amount',
    description: 'UWM Insights API field BaseLoanAmount (Decimal). Read straight from the raw UWM payload.',
    type: 'number',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_Borr1ConsentToEsign',
    path: 'uwm.Borr1ConsentToEsign',
    sourceUwmField: 'Borr1ConsentToEsign',
    source: 'uwm',
    label: 'UWM · Borr1 Consent To E-sign',
    description: 'UWM Insights API field Borr1ConsentToEsign (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'borrower',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_Borr1LinkDelivered',
    path: 'uwm.Borr1LinkDelivered',
    sourceUwmField: 'Borr1LinkDelivered',
    source: 'uwm',
    label: 'UWM · Borr1 Link Delivered',
    description: 'UWM Insights API field Borr1LinkDelivered (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'borrower',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_Borr1SignedAndSubmitted',
    path: 'uwm.Borr1SignedAndSubmitted',
    sourceUwmField: 'Borr1SignedAndSubmitted',
    source: 'uwm',
    label: 'UWM · Borr1 Signed And Submitted',
    description: 'UWM Insights API field Borr1SignedAndSubmitted (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'borrower',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_Borr2ConsentToEsign',
    path: 'uwm.Borr2ConsentToEsign',
    sourceUwmField: 'Borr2ConsentToEsign',
    source: 'uwm',
    label: 'UWM · Borr2 Consent To E-sign',
    description: 'UWM Insights API field Borr2ConsentToEsign (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'borrower',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_Borr2LinkDelivered',
    path: 'uwm.Borr2LinkDelivered',
    sourceUwmField: 'Borr2LinkDelivered',
    source: 'uwm',
    label: 'UWM · Borr2 Link Delivered',
    description: 'UWM Insights API field Borr2LinkDelivered (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'borrower',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_Borr2SignedAndSubmitted',
    path: 'uwm.Borr2SignedAndSubmitted',
    sourceUwmField: 'Borr2SignedAndSubmitted',
    source: 'uwm',
    label: 'UWM · Borr2 Signed And Submitted',
    description: 'UWM Insights API field Borr2SignedAndSubmitted (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'borrower',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_BorrowerEmail',
    path: 'uwm.BorrowerEmail',
    sourceUwmField: 'BorrowerEmail',
    source: 'uwm',
    label: 'UWM · Borrower Email',
    description: 'UWM Insights API field BorrowerEmail (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'borrower',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_BorrowerHomePhoneNumber',
    path: 'uwm.BorrowerHomePhoneNumber',
    sourceUwmField: 'BorrowerHomePhoneNumber',
    source: 'uwm',
    label: 'UWM · Borrower Home Phone Number',
    description: 'UWM Insights API field BorrowerHomePhoneNumber (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'borrower',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_BorrowerIncome',
    path: 'uwm.BorrowerIncome',
    sourceUwmField: 'BorrowerIncome',
    source: 'uwm',
    label: 'UWM · Borrower Income',
    description: 'UWM Insights API field BorrowerIncome (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'borrower',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_BorrowerQualifyingIncome',
    path: 'uwm.BorrowerQualifyingIncome',
    sourceUwmField: 'BorrowerQualifyingIncome',
    source: 'uwm',
    label: 'UWM · Borrower Qualifying Income',
    description: 'UWM Insights API field BorrowerQualifyingIncome (Decimal). Read straight from the raw UWM payload.',
    type: 'number',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'borrower',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_BrokerCompensation',
    path: 'uwm.BrokerCompensation',
    sourceUwmField: 'BrokerCompensation',
    source: 'uwm',
    label: 'UWM · Broker Compensation',
    description: 'UWM Insights API field BrokerCompensation (Decimal). Read straight from the raw UWM payload.',
    type: 'number',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_BrokerID',
    path: 'uwm.BrokerID',
    sourceUwmField: 'BrokerID',
    source: 'uwm',
    label: 'UWM · Broker ID',
    description: 'UWM Insights API field BrokerID (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_BusDaysBwsubCtc',
    path: 'uwm.BusDaysBwsubCtc',
    sourceUwmField: 'BusDaysBwsubCtc',
    source: 'uwm',
    label: 'UWM · Bus Days Bwsub Ctc',
    description: 'UWM Insights API field BusDaysBwsubCtc (Integer). Read straight from the raw UWM payload.',
    type: 'integer',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_BuydownAlias',
    path: 'uwm.BuydownAlias',
    sourceUwmField: 'BuydownAlias',
    source: 'uwm',
    label: 'UWM · Buydown Alias',
    description: 'UWM Insights API field BuydownAlias (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_BuydownDescription',
    path: 'uwm.BuydownDescription',
    sourceUwmField: 'BuydownDescription',
    source: 'uwm',
    label: 'UWM · Buydown Description',
    description: 'UWM Insights API field BuydownDescription (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_BuydownID',
    path: 'uwm.BuydownID',
    sourceUwmField: 'BuydownID',
    source: 'uwm',
    label: 'UWM · Buydown ID',
    description: 'UWM Insights API field BuydownID (Integer). Read straight from the raw UWM payload.',
    type: 'integer',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_BuyerRealEstateAddress',
    path: 'uwm.BuyerRealEstateAddress',
    sourceUwmField: 'BuyerRealEstateAddress',
    source: 'uwm',
    label: 'UWM · Buyer Real Estate Address',
    description: 'UWM Insights API field BuyerRealEstateAddress (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_BuyerRealEstateAgency',
    path: 'uwm.BuyerRealEstateAgency',
    sourceUwmField: 'BuyerRealEstateAgency',
    source: 'uwm',
    label: 'UWM · Buyer Real Estate Agency',
    description: 'UWM Insights API field BuyerRealEstateAgency (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_BuyerRealEstateAgencyLicense',
    path: 'uwm.BuyerRealEstateAgencyLicense',
    sourceUwmField: 'BuyerRealEstateAgencyLicense',
    source: 'uwm',
    label: 'UWM · Buyer Real Estate Agency License',
    description: 'UWM Insights API field BuyerRealEstateAgencyLicense (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_BuyerRealEstateAgencyNMLS',
    path: 'uwm.BuyerRealEstateAgencyNMLS',
    sourceUwmField: 'BuyerRealEstateAgencyNMLS',
    source: 'uwm',
    label: 'UWM · Buyer Real Estate Agency NMLS',
    description: 'UWM Insights API field BuyerRealEstateAgencyNMLS (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_BuyerRealEstateAgentEmail',
    path: 'uwm.BuyerRealEstateAgentEmail',
    sourceUwmField: 'BuyerRealEstateAgentEmail',
    source: 'uwm',
    label: 'UWM · Buyer Real Estate Agent Email',
    description: 'UWM Insights API field BuyerRealEstateAgentEmail (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_BuyerRealEstateAgentLicense',
    path: 'uwm.BuyerRealEstateAgentLicense',
    sourceUwmField: 'BuyerRealEstateAgentLicense',
    source: 'uwm',
    label: 'UWM · Buyer Real Estate Agent License',
    description: 'UWM Insights API field BuyerRealEstateAgentLicense (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_BuyerRealEstateAgentName',
    path: 'uwm.BuyerRealEstateAgentName',
    sourceUwmField: 'BuyerRealEstateAgentName',
    source: 'uwm',
    label: 'UWM · Buyer Real Estate Agent Name',
    description: 'UWM Insights API field BuyerRealEstateAgentName (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_BuyerRealEstateAgentNMLS',
    path: 'uwm.BuyerRealEstateAgentNMLS',
    sourceUwmField: 'BuyerRealEstateAgentNMLS',
    source: 'uwm',
    label: 'UWM · Buyer Real Estate Agent NMLS',
    description: 'UWM Insights API field BuyerRealEstateAgentNMLS (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_BuyerRealEstateAgentPhone',
    path: 'uwm.BuyerRealEstateAgentPhone',
    sourceUwmField: 'BuyerRealEstateAgentPhone',
    source: 'uwm',
    label: 'UWM · Buyer Real Estate Agent Phone',
    description: 'UWM Insights API field BuyerRealEstateAgentPhone (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_BuyerRealEstateCity',
    path: 'uwm.BuyerRealEstateCity',
    sourceUwmField: 'BuyerRealEstateCity',
    source: 'uwm',
    label: 'UWM · Buyer Real Estate City',
    description: 'UWM Insights API field BuyerRealEstateCity (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_BuyerRealEstateState',
    path: 'uwm.BuyerRealEstateState',
    sourceUwmField: 'BuyerRealEstateState',
    source: 'uwm',
    label: 'UWM · Buyer Real Estate State',
    description: 'UWM Insights API field BuyerRealEstateState (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_BuyerRealEstateZipCode',
    path: 'uwm.BuyerRealEstateZipCode',
    sourceUwmField: 'BuyerRealEstateZipCode',
    source: 'uwm',
    label: 'UWM · Buyer Real Estate Zip Code',
    description: 'UWM Insights API field BuyerRealEstateZipCode (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_CannotCloseBefore',
    path: 'uwm.CannotCloseBefore',
    sourceUwmField: 'CannotCloseBefore',
    source: 'uwm',
    label: 'UWM · Cannot Close Before',
    description: 'UWM Insights API field CannotCloseBefore (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_CashtoClose',
    path: 'uwm.CashtoClose',
    sourceUwmField: 'CashtoClose',
    source: 'uwm',
    label: 'UWM · Cashto Close',
    description: 'UWM Insights API field CashtoClose (Float). Read straight from the raw UWM payload.',
    type: 'number',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_CashtoCloseAvailable',
    path: 'uwm.CashtoCloseAvailable',
    sourceUwmField: 'CashtoCloseAvailable',
    source: 'uwm',
    label: 'UWM · Cashto Close Available',
    description: 'UWM Insights API field CashtoCloseAvailable (Decimal). Read straight from the raw UWM payload.',
    type: 'number',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_CDSignedDatetime',
    path: 'uwm.CDSignedDatetime',
    sourceUwmField: 'CDSignedDatetime',
    source: 'uwm',
    label: 'UWM · CD Signed Datetime',
    description: 'UWM Insights API field CDSignedDatetime (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_CDSignedFlag',
    path: 'uwm.CDSignedFlag',
    sourceUwmField: 'CDSignedFlag',
    source: 'uwm',
    label: 'UWM · CD Signed Flag',
    description: 'UWM Insights API field CDSignedFlag (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_ClosingDateTime',
    path: 'uwm.ClosingDateTime',
    sourceUwmField: 'ClosingDateTime',
    source: 'uwm',
    label: 'UWM · Closing Date Time',
    description: 'UWM Insights API field ClosingDateTime (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'closing',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_ClosingDisclosureDateTime',
    path: 'uwm.ClosingDisclosureDateTime',
    sourceUwmField: 'ClosingDisclosureDateTime',
    source: 'uwm',
    label: 'UWM · Closing Disclosure Date Time',
    description: 'UWM Insights API field ClosingDisclosureDateTime (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'closing',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_ClosingPackageReceivedDate',
    path: 'uwm.ClosingPackageReceivedDate',
    sourceUwmField: 'ClosingPackageReceivedDate',
    source: 'uwm',
    label: 'UWM · Closing Package Received Date',
    description: 'UWM Insights API field ClosingPackageReceivedDate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'closing',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_CLTV',
    path: 'uwm.CLTV',
    sourceUwmField: 'CLTV',
    source: 'uwm',
    label: 'UWM · CLTV',
    description: 'UWM Insights API field CLTV (Decimal). Read straight from the raw UWM payload.',
    type: 'number',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_CoBorrowerTotalIncome',
    path: 'uwm.CoBorrowerTotalIncome',
    sourceUwmField: 'CoBorrowerTotalIncome',
    source: 'uwm',
    label: 'UWM · Co Borrower Total Income',
    description: 'UWM Insights API field CoBorrowerTotalIncome (Decimal). Read straight from the raw UWM payload.',
    type: 'number',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'borrower',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_CoBorrowerVVOEExpirationDateTime',
    path: 'uwm.CoBorrowerVVOEExpirationDateTime',
    sourceUwmField: 'CoBorrowerVVOEExpirationDateTime',
    source: 'uwm',
    label: 'UWM · Co Borrower Vvoe Expiration Date Time',
    description: 'UWM Insights API field CoBorrowerVVOEExpirationDateTime (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'borrower',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_CoBorrowerVVOEReceivedDateTime',
    path: 'uwm.CoBorrowerVVOEReceivedDateTime',
    sourceUwmField: 'CoBorrowerVVOEReceivedDateTime',
    source: 'uwm',
    label: 'UWM · Co Borrower Vvoe Received Date Time',
    description: 'UWM Insights API field CoBorrowerVVOEReceivedDateTime (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'borrower',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_CoCIndicator',
    path: 'uwm.CoCIndicator',
    sourceUwmField: 'CoCIndicator',
    source: 'uwm',
    label: 'UWM · Co C Indicator',
    description: 'UWM Insights API field CoCIndicator (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_CompensationType',
    path: 'uwm.CompensationType',
    sourceUwmField: 'CompensationType',
    source: 'uwm',
    label: 'UWM · Compensation Type',
    description: 'UWM Insights API field CompensationType (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_ContingencyDate',
    path: 'uwm.ContingencyDate',
    sourceUwmField: 'ContingencyDate',
    source: 'uwm',
    label: 'UWM · Contingency Date',
    description: 'UWM Insights API field ContingencyDate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'dates',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_CorrespondentInd',
    path: 'uwm.CorrespondentInd',
    sourceUwmField: 'CorrespondentInd',
    source: 'uwm',
    label: 'UWM · Correspondent Ind',
    description: 'UWM Insights API field CorrespondentInd (Integer). Read straight from the raw UWM payload.',
    type: 'integer',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_CreditExpDate',
    path: 'uwm.CreditExpDate',
    sourceUwmField: 'CreditExpDate',
    source: 'uwm',
    label: 'UWM · Credit Exp Date',
    description: 'UWM Insights API field CreditExpDate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'dates',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_CreditReportFee',
    path: 'uwm.CreditReportFee',
    sourceUwmField: 'CreditReportFee',
    source: 'uwm',
    label: 'UWM · Credit Report Fee',
    description: 'UWM Insights API field CreditReportFee (Decimal). Read straight from the raw UWM payload.',
    type: 'number',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'closing',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_CreditReportReimbursement',
    path: 'uwm.CreditReportReimbursement',
    sourceUwmField: 'CreditReportReimbursement',
    source: 'uwm',
    label: 'UWM · Credit Report Reimbursement',
    description: 'UWM Insights API field CreditReportReimbursement (Integer). Read straight from the raw UWM payload.',
    type: 'integer',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'closing',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_CTCDateTime',
    path: 'uwm.CTCDateTime',
    sourceUwmField: 'CTCDateTime',
    source: 'uwm',
    label: 'UWM · Ctc Date Time',
    description: 'UWM Insights API field CTCDateTime (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_CurrentCDDate',
    path: 'uwm.CurrentCDDate',
    sourceUwmField: 'CurrentCDDate',
    source: 'uwm',
    label: 'UWM · Current CD Date',
    description: 'UWM Insights API field CurrentCDDate (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_CurrentProblemUpload',
    path: 'uwm.CurrentProblemUpload',
    sourceUwmField: 'CurrentProblemUpload',
    source: 'uwm',
    label: 'UWM · Current Problem Upload',
    description: 'UWM Insights API field CurrentProblemUpload (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_CustomLockUsedFlag',
    path: 'uwm.CustomLockUsedFlag',
    sourceUwmField: 'CustomLockUsedFlag',
    source: 'uwm',
    label: 'UWM · Custom Lock Used Flag',
    description: 'UWM Insights API field CustomLockUsedFlag (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'lock',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_DateOfFirstPayment',
    path: 'uwm.DateOfFirstPayment',
    sourceUwmField: 'DateOfFirstPayment',
    source: 'uwm',
    label: 'UWM · Date Of First Payment',
    description: 'UWM Insights API field DateOfFirstPayment (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'dates',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_DaysSinceSubmission',
    path: 'uwm.DaysSinceSubmission',
    sourceUwmField: 'DaysSinceSubmission',
    source: 'uwm',
    label: 'UWM · Days Since Submission',
    description: 'UWM Insights API field DaysSinceSubmission (Integer). Read straight from the raw UWM payload.',
    type: 'integer',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_DisbursementDate',
    path: 'uwm.DisbursementDate',
    sourceUwmField: 'DisbursementDate',
    source: 'uwm',
    label: 'UWM · Disbursement Date',
    description: 'UWM Insights API field DisbursementDate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'closing',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_DiscountPoint',
    path: 'uwm.DiscountPoint',
    sourceUwmField: 'DiscountPoint',
    source: 'uwm',
    label: 'UWM · Discount Point',
    description: 'UWM Insights API field DiscountPoint (Decimal). Read straight from the raw UWM payload.',
    type: 'number',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_DocLessIsProcessed',
    path: 'uwm.DocLessIsProcessed',
    sourceUwmField: 'DocLessIsProcessed',
    source: 'uwm',
    label: 'UWM · Doc Less Is Processed',
    description: 'UWM Insights API field DocLessIsProcessed (Boolean). Read straight from the raw UWM payload.',
    type: 'boolean_yn',
    enumValues: [
      { value: 'Y', label: 'Yes' },
      { value: 'N', label: 'No' },
    ],
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: 'Y',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_DocLessUsedFlag',
    path: 'uwm.DocLessUsedFlag',
    sourceUwmField: 'DocLessUsedFlag',
    source: 'uwm',
    label: 'UWM · Doc Less Used Flag',
    description: 'UWM Insights API field DocLessUsedFlag (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_DTIBackEnd',
    path: 'uwm.DTIBackEnd',
    sourceUwmField: 'DTIBackEnd',
    source: 'uwm',
    label: 'UWM · DTI Back End',
    description: 'UWM Insights API field DTIBackEnd (Float). Read straight from the raw UWM payload.',
    type: 'number',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_DTIFrontEnd',
    path: 'uwm.DTIFrontEnd',
    sourceUwmField: 'DTIFrontEnd',
    source: 'uwm',
    label: 'UWM · DTI Front End',
    description: 'UWM Insights API field DTIFrontEnd (Float). Read straight from the raw UWM payload.',
    type: 'number',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_EaseUrl',
    path: 'uwm.EaseUrl',
    sourceUwmField: 'EaseUrl',
    source: 'uwm',
    label: 'UWM · Ease URL',
    description: 'UWM Insights API field EaseUrl (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_EPODate',
    path: 'uwm.EPODate',
    sourceUwmField: 'EPODate',
    source: 'uwm',
    label: 'UWM · EPO Date',
    description: 'UWM Insights API field EPODate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'closing',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_EscrowTotal',
    path: 'uwm.EscrowTotal',
    sourceUwmField: 'EscrowTotal',
    source: 'uwm',
    label: 'UWM · Escrow Total',
    description: 'UWM Insights API field EscrowTotal (Decimal). Read straight from the raw UWM payload.',
    type: 'number',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_EsignCompletedDate',
    path: 'uwm.EsignCompletedDate',
    sourceUwmField: 'EsignCompletedDate',
    source: 'uwm',
    label: 'UWM · E-sign Completed Date',
    description: 'UWM Insights API field EsignCompletedDate (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_ESignCompletedFlag',
    path: 'uwm.ESignCompletedFlag',
    sourceUwmField: 'ESignCompletedFlag',
    source: 'uwm',
    label: 'UWM · E Sign Completed Flag',
    description: 'UWM Insights API field ESignCompletedFlag (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_EstimatedClosingDate',
    path: 'uwm.EstimatedClosingDate',
    sourceUwmField: 'EstimatedClosingDate',
    source: 'uwm',
    label: 'UWM · Estimated Closing Date',
    description: 'UWM Insights API field EstimatedClosingDate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'closing',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_ExactRateUsedFlag',
    path: 'uwm.ExactRateUsedFlag',
    sourceUwmField: 'ExactRateUsedFlag',
    source: 'uwm',
    label: 'UWM · Exact Rate Used Flag',
    description: 'UWM Insights API field ExactRateUsedFlag (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_Expiration',
    path: 'uwm.Expiration',
    sourceUwmField: 'Expiration',
    source: 'uwm',
    label: 'UWM · Expiration',
    description: 'UWM Insights API field Expiration (Date). Read straight from the raw UWM payload.',
    type: 'date',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01',
    category: 'dates',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_FederalReferenceNumber',
    path: 'uwm.FederalReferenceNumber',
    sourceUwmField: 'FederalReferenceNumber',
    source: 'uwm',
    label: 'UWM · Federal Reference Number',
    description: 'UWM Insights API field FederalReferenceNumber (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_FHACaseNumber',
    path: 'uwm.FHACaseNumber',
    sourceUwmField: 'FHACaseNumber',
    source: 'uwm',
    label: 'UWM · FHA Case Number',
    description: 'UWM Insights API field FHACaseNumber (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_FHAUpfrontMortgageInsurancePremium',
    path: 'uwm.FHAUpfrontMortgageInsurancePremium',
    sourceUwmField: 'FHAUpfrontMortgageInsurancePremium',
    source: 'uwm',
    label: 'UWM · FHA Upfront Mortgage Insurance Premium',
    description: 'UWM Insights API field FHAUpfrontMortgageInsurancePremium (Integer). Read straight from the raw UWM payload.',
    type: 'integer',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_FICO',
    path: 'uwm.FICO',
    sourceUwmField: 'FICO',
    source: 'uwm',
    label: 'UWM · Fico',
    description: 'UWM Insights API field FICO (Integer). Read straight from the raw UWM payload.',
    type: 'integer',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_FinalCDDateTime',
    path: 'uwm.FinalCDDateTime',
    sourceUwmField: 'FinalCDDateTime',
    source: 'uwm',
    label: 'UWM · Final CD Date Time',
    description: 'UWM Insights API field FinalCDDateTime (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_FinalCredit',
    path: 'uwm.FinalCredit',
    sourceUwmField: 'FinalCredit',
    source: 'uwm',
    label: 'UWM · Final Credit',
    description: 'UWM Insights API field FinalCredit (Decimal). Read straight from the raw UWM payload.',
    type: 'number',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_FinalCreditAmount',
    path: 'uwm.FinalCreditAmount',
    sourceUwmField: 'FinalCreditAmount',
    source: 'uwm',
    label: 'UWM · Final Credit Amount',
    description: 'UWM Insights API field FinalCreditAmount (Decimal). Read straight from the raw UWM payload.',
    type: 'number',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_FinalPrice',
    path: 'uwm.FinalPrice',
    sourceUwmField: 'FinalPrice',
    source: 'uwm',
    label: 'UWM · Final Price',
    description: 'UWM Insights API field FinalPrice (Decimal). Read straight from the raw UWM payload.',
    type: 'number',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_FundedDate',
    path: 'uwm.FundedDate',
    sourceUwmField: 'FundedDate',
    source: 'uwm',
    label: 'UWM · Funded Date',
    description: 'UWM Insights API field FundedDate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'closing',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_FundingFee',
    path: 'uwm.FundingFee',
    sourceUwmField: 'FundingFee',
    source: 'uwm',
    label: 'UWM · Funding Fee',
    description: 'UWM Insights API field FundingFee (Integer). Read straight from the raw UWM payload.',
    type: 'integer',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'closing',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_HCLTV',
    path: 'uwm.HCLTV',
    sourceUwmField: 'HCLTV',
    source: 'uwm',
    label: 'UWM · Hcltv',
    description: 'UWM Insights API field HCLTV (Decimal). Read straight from the raw UWM payload.',
    type: 'number',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_HighCostTestResult',
    path: 'uwm.HighCostTestResult',
    sourceUwmField: 'HighCostTestResult',
    source: 'uwm',
    label: 'UWM · High Cost Test Result',
    description: 'UWM Insights API field HighCostTestResult (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_HMDAActionDate',
    path: 'uwm.HMDAActionDate',
    sourceUwmField: 'HMDAActionDate',
    source: 'uwm',
    label: 'UWM · Hmda Action Date',
    description: 'UWM Insights API field HMDAActionDate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'dates',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_HOIExpirationDate',
    path: 'uwm.HOIExpirationDate',
    sourceUwmField: 'HOIExpirationDate',
    source: 'uwm',
    label: 'UWM · HOI Expiration Date',
    description: 'UWM Insights API field HOIExpirationDate (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'dates',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_ImportedDateTime',
    path: 'uwm.ImportedDateTime',
    sourceUwmField: 'ImportedDateTime',
    source: 'uwm',
    label: 'UWM · Imported Date Time',
    description: 'UWM Insights API field ImportedDateTime (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'dates',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_IncomeExpirationDate',
    path: 'uwm.IncomeExpirationDate',
    sourceUwmField: 'IncomeExpirationDate',
    source: 'uwm',
    label: 'UWM · Income Expiration Date',
    description: 'UWM Insights API field IncomeExpirationDate (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'dates',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_InitialCDDateTime',
    path: 'uwm.InitialCDDateTime',
    sourceUwmField: 'InitialCDDateTime',
    source: 'uwm',
    label: 'UWM · Initial CD Date Time',
    description: 'UWM Insights API field InitialCDDateTime (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_InitialLoanEstimateDate',
    path: 'uwm.InitialLoanEstimateDate',
    sourceUwmField: 'InitialLoanEstimateDate',
    source: 'uwm',
    label: 'UWM · Initial Loan Estimate Date',
    description: 'UWM Insights API field InitialLoanEstimateDate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'dates',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_InspectionScheduledDate',
    path: 'uwm.InspectionScheduledDate',
    sourceUwmField: 'InspectionScheduledDate',
    source: 'uwm',
    label: 'UWM · Inspection Scheduled Date',
    description: 'UWM Insights API field InspectionScheduledDate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_Investor',
    path: 'uwm.Investor',
    sourceUwmField: 'Investor',
    source: 'uwm',
    label: 'UWM · Investor',
    description: 'UWM Insights API field Investor (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_LenderCredits',
    path: 'uwm.LenderCredits',
    sourceUwmField: 'LenderCredits',
    source: 'uwm',
    label: 'UWM · Lender Credits',
    description: 'UWM Insights API field LenderCredits (Decimal). Read straight from the raw UWM payload.',
    type: 'number',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_LoanId',
    path: 'uwm.LoanId',
    sourceUwmField: 'LoanId',
    source: 'uwm',
    label: 'UWM · Loan ID',
    description: 'UWM Insights API field LoanId (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_LoanOfficerFullName',
    path: 'uwm.LoanOfficerFullName',
    sourceUwmField: 'LoanOfficerFullName',
    source: 'uwm',
    label: 'UWM · Loan Officer Full Name',
    description: 'UWM Insights API field LoanOfficerFullName (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_LoanProgram',
    path: 'uwm.LoanProgram',
    sourceUwmField: 'LoanProgram',
    source: 'uwm',
    label: 'UWM · Loan Program',
    description: 'UWM Insights API field LoanProgram (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_LoanRate',
    path: 'uwm.LoanRate',
    sourceUwmField: 'LoanRate',
    source: 'uwm',
    label: 'UWM · Loan Rate',
    description: 'UWM Insights API field LoanRate (Decimal). Read straight from the raw UWM payload.',
    type: 'number',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_LoanShield',
    path: 'uwm.LoanShield',
    sourceUwmField: 'LoanShield',
    source: 'uwm',
    label: 'UWM · Loan Shield',
    description: 'UWM Insights API field LoanShield (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_LoanStatusDescription',
    path: 'uwm.LoanStatusDescription',
    sourceUwmField: 'LoanStatusDescription',
    source: 'uwm',
    label: 'UWM · Loan Status Description',
    description: 'UWM Insights API field LoanStatusDescription (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'status',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_LoanType',
    path: 'uwm.LoanType',
    sourceUwmField: 'LoanType',
    source: 'uwm',
    label: 'UWM · Loan Type',
    description: 'UWM Insights API field LoanType (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_LockActionDescription',
    path: 'uwm.LockActionDescription',
    sourceUwmField: 'LockActionDescription',
    source: 'uwm',
    label: 'UWM · Lock Action Description',
    description: 'UWM Insights API field LockActionDescription (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'lock',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_LockDate',
    path: 'uwm.LockDate',
    sourceUwmField: 'LockDate',
    source: 'uwm',
    label: 'UWM · Lock Date',
    description: 'UWM Insights API field LockDate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'lock',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_LockExpiration',
    path: 'uwm.LockExpiration',
    sourceUwmField: 'LockExpiration',
    source: 'uwm',
    label: 'UWM · Lock Expiration',
    description: 'UWM Insights API field LockExpiration (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'lock',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_LockExpirationDate',
    path: 'uwm.LockExpirationDate',
    sourceUwmField: 'LockExpirationDate',
    source: 'uwm',
    label: 'UWM · Lock Expiration Date',
    description: 'UWM Insights API field LockExpirationDate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'lock',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_LockExpired',
    path: 'uwm.LockExpired',
    sourceUwmField: 'LockExpired',
    source: 'uwm',
    label: 'UWM · Lock Expired',
    description: 'UWM Insights API field LockExpired (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'lock',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_LockFirstExtension',
    path: 'uwm.LockFirstExtension',
    sourceUwmField: 'LockFirstExtension',
    source: 'uwm',
    label: 'UWM · Lock First Extension',
    description: 'UWM Insights API field LockFirstExtension (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'lock',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_LockSecondExtension',
    path: 'uwm.LockSecondExtension',
    sourceUwmField: 'LockSecondExtension',
    source: 'uwm',
    label: 'UWM · Lock Second Extension',
    description: 'UWM Insights API field LockSecondExtension (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'lock',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_LockStatus',
    path: 'uwm.LockStatus',
    sourceUwmField: 'LockStatus',
    source: 'uwm',
    label: 'UWM · Lock Status',
    description: 'UWM Insights API field LockStatus (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'lock',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_LOConsentToEsign',
    path: 'uwm.LOConsentToEsign',
    sourceUwmField: 'LOConsentToEsign',
    source: 'uwm',
    label: 'UWM · LO Consent To E-sign',
    description: 'UWM Insights API field LOConsentToEsign (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_LOlinkDelivered',
    path: 'uwm.LOlinkDelivered',
    sourceUwmField: 'LOlinkDelivered',
    source: 'uwm',
    label: 'UWM · L Olink Delivered',
    description: 'UWM Insights API field LOlinkDelivered (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_LOPP',
    path: 'uwm.LOPP',
    sourceUwmField: 'LOPP',
    source: 'uwm',
    label: 'UWM · Lopp',
    description: 'UWM Insights API field LOPP (Decimal). Read straight from the raw UWM payload.',
    type: 'number',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_LOSignedAndSubmitted',
    path: 'uwm.LOSignedAndSubmitted',
    sourceUwmField: 'LOSignedAndSubmitted',
    source: 'uwm',
    label: 'UWM · LO Signed And Submitted',
    description: 'UWM Insights API field LOSignedAndSubmitted (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_LTV',
    path: 'uwm.LTV',
    sourceUwmField: 'LTV',
    source: 'uwm',
    label: 'UWM · LTV',
    description: 'UWM Insights API field LTV (Decimal). Read straight from the raw UWM payload.',
    type: 'number',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_MannerHeld',
    path: 'uwm.MannerHeld',
    sourceUwmField: 'MannerHeld',
    source: 'uwm',
    label: 'UWM · Manner Held',
    description: 'UWM Insights API field MannerHeld (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_MItype',
    path: 'uwm.MItype',
    sourceUwmField: 'MItype',
    source: 'uwm',
    label: 'UWM · M Itype',
    description: 'UWM Insights API field MItype (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_MonthlyMortgageInsurance',
    path: 'uwm.MonthlyMortgageInsurance',
    sourceUwmField: 'MonthlyMortgageInsurance',
    source: 'uwm',
    label: 'UWM · Monthly Mortgage Insurance',
    description: 'UWM Insights API field MonthlyMortgageInsurance (Decimal). Read straight from the raw UWM payload.',
    type: 'number',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_MortgageAppliedFor',
    path: 'uwm.MortgageAppliedFor',
    sourceUwmField: 'MortgageAppliedFor',
    source: 'uwm',
    label: 'UWM · Mortgage Applied For',
    description: 'UWM Insights API field MortgageAppliedFor (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_MortgageInsurancePremium',
    path: 'uwm.MortgageInsurancePremium',
    sourceUwmField: 'MortgageInsurancePremium',
    source: 'uwm',
    label: 'UWM · Mortgage Insurance Premium',
    description: 'UWM Insights API field MortgageInsurancePremium (Decimal). Read straight from the raw UWM payload.',
    type: 'number',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_MostRecentCDDateTime',
    path: 'uwm.MostRecentCDDateTime',
    sourceUwmField: 'MostRecentCDDateTime',
    source: 'uwm',
    label: 'UWM · Most Recent CD Date Time',
    description: 'UWM Insights API field MostRecentCDDateTime (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_MostRecentConditionDatetime',
    path: 'uwm.MostRecentConditionDatetime',
    sourceUwmField: 'MostRecentConditionDatetime',
    source: 'uwm',
    label: 'UWM · Most Recent Condition Datetime',
    description: 'UWM Insights API field MostRecentConditionDatetime (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'parties',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_MostRecentLESignatureDateTime',
    path: 'uwm.MostRecentLESignatureDateTime',
    sourceUwmField: 'MostRecentLESignatureDateTime',
    source: 'uwm',
    label: 'UWM · Most Recent LE Signature Date Time',
    description: 'UWM Insights API field MostRecentLESignatureDateTime (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_MostRecentLoanEstimateDate',
    path: 'uwm.MostRecentLoanEstimateDate',
    sourceUwmField: 'MostRecentLoanEstimateDate',
    source: 'uwm',
    label: 'UWM · Most Recent Loan Estimate Date',
    description: 'UWM Insights API field MostRecentLoanEstimateDate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'dates',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_MostRecentRelockDate',
    path: 'uwm.MostRecentRelockDate',
    sourceUwmField: 'MostRecentRelockDate',
    source: 'uwm',
    label: 'UWM · Most Recent Relock Date',
    description: 'UWM Insights API field MostRecentRelockDate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'lock',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_NoteReceivedDate',
    path: 'uwm.NoteReceivedDate',
    sourceUwmField: 'NoteReceivedDate',
    source: 'uwm',
    label: 'UWM · Note Received Date',
    description: 'UWM Insights API field NoteReceivedDate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'dates',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_NumberOfPayment',
    path: 'uwm.NumberOfPayment',
    sourceUwmField: 'NumberOfPayment',
    source: 'uwm',
    label: 'UWM · Number Of Payment',
    description: 'UWM Insights API field NumberOfPayment (Integer). Read straight from the raw UWM payload.',
    type: 'integer',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_NumberOfUnits',
    path: 'uwm.NumberOfUnits',
    sourceUwmField: 'NumberOfUnits',
    source: 'uwm',
    label: 'UWM · Number Of Units',
    description: 'UWM Insights API field NumberOfUnits (Short). Read straight from the raw UWM payload.',
    type: 'integer',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_ObfuscatedLoanRecordId',
    path: 'uwm.ObfuscatedLoanRecordId',
    sourceUwmField: 'ObfuscatedLoanRecordId',
    source: 'uwm',
    label: 'UWM · Obfuscated Loan Record ID',
    description: 'UWM Insights API field ObfuscatedLoanRecordId (Integer). Read straight from the raw UWM payload.',
    type: 'integer',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_OccupancyType',
    path: 'uwm.OccupancyType',
    sourceUwmField: 'OccupancyType',
    source: 'uwm',
    label: 'UWM · Occupancy Type',
    description: 'UWM Insights API field OccupancyType (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_OneClickUsedFlag',
    path: 'uwm.OneClickUsedFlag',
    sourceUwmField: 'OneClickUsedFlag',
    source: 'uwm',
    label: 'UWM · One Click Used Flag',
    description: 'UWM Insights API field OneClickUsedFlag (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_OutstandingCondition',
    path: 'uwm.OutstandingCondition',
    sourceUwmField: 'OutstandingCondition',
    source: 'uwm',
    label: 'UWM · Outstanding Condition',
    description: 'UWM Insights API field OutstandingCondition (Integer). Read straight from the raw UWM payload.',
    type: 'integer',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'parties',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_PaidInFullDate',
    path: 'uwm.PaidInFullDate',
    sourceUwmField: 'PaidInFullDate',
    source: 'uwm',
    label: 'UWM · Paid In Full Date',
    description: 'UWM Insights API field PaidInFullDate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'dates',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_PayOffExpirationDate',
    path: 'uwm.PayOffExpirationDate',
    sourceUwmField: 'PayOffExpirationDate',
    source: 'uwm',
    label: 'UWM · Pay Off Expiration Date',
    description: 'UWM Insights API field PayOffExpirationDate (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'dates',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_PITI',
    path: 'uwm.PITI',
    sourceUwmField: 'PITI',
    source: 'uwm',
    label: 'UWM · Piti',
    description: 'UWM Insights API field PITI (Decimal). Read straight from the raw UWM payload.',
    type: 'number',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_PrimaryBorrowerFirstName',
    path: 'uwm.PrimaryBorrowerFirstName',
    sourceUwmField: 'PrimaryBorrowerFirstName',
    source: 'uwm',
    label: 'UWM · Primary Borrower First Name',
    description: 'UWM Insights API field PrimaryBorrowerFirstName (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'borrower',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_PrimaryBorrowerLastName',
    path: 'uwm.PrimaryBorrowerLastName',
    sourceUwmField: 'PrimaryBorrowerLastName',
    source: 'uwm',
    label: 'UWM · Primary Borrower Last Name',
    description: 'UWM Insights API field PrimaryBorrowerLastName (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'borrower',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_ProblemUpload',
    path: 'uwm.ProblemUpload',
    sourceUwmField: 'ProblemUpload',
    source: 'uwm',
    label: 'UWM · Problem Upload',
    description: 'UWM Insights API field ProblemUpload (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_ProcessingFee',
    path: 'uwm.ProcessingFee',
    sourceUwmField: 'ProcessingFee',
    source: 'uwm',
    label: 'UWM · Processing Fee',
    description: 'UWM Insights API field ProcessingFee (Decimal). Read straight from the raw UWM payload.',
    type: 'number',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_ProcessorAssistOrderComplete',
    path: 'uwm.ProcessorAssistOrderComplete',
    sourceUwmField: 'ProcessorAssistOrderComplete',
    source: 'uwm',
    label: 'UWM · Processor Assist Order Complete',
    description: 'UWM Insights API field ProcessorAssistOrderComplete (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'parties',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_ProcessorAssistOrderOutStanding',
    path: 'uwm.ProcessorAssistOrderOutStanding',
    sourceUwmField: 'ProcessorAssistOrderOutStanding',
    source: 'uwm',
    label: 'UWM · Processor Assist Order Out Standing',
    description: 'UWM Insights API field ProcessorAssistOrderOutStanding (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'parties',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_ProcessorAssistUsedFlag',
    path: 'uwm.ProcessorAssistUsedFlag',
    sourceUwmField: 'ProcessorAssistUsedFlag',
    source: 'uwm',
    label: 'UWM · Processor Assist Used Flag',
    description: 'UWM Insights API field ProcessorAssistUsedFlag (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'parties',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_ProcessorEmail',
    path: 'uwm.ProcessorEmail',
    sourceUwmField: 'ProcessorEmail',
    source: 'uwm',
    label: 'UWM · Processor Email',
    description: 'UWM Insights API field ProcessorEmail (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'parties',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_ProcessorFullName',
    path: 'uwm.ProcessorFullName',
    sourceUwmField: 'ProcessorFullName',
    source: 'uwm',
    label: 'UWM · Processor Full Name',
    description: 'UWM Insights API field ProcessorFullName (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'parties',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_Product',
    path: 'uwm.Product',
    sourceUwmField: 'Product',
    source: 'uwm',
    label: 'UWM · Product',
    description: 'UWM Insights API field Product (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_PropertyType',
    path: 'uwm.PropertyType',
    sourceUwmField: 'PropertyType',
    source: 'uwm',
    label: 'UWM · Property Type',
    description: 'UWM Insights API field PropertyType (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_Purpose',
    path: 'uwm.Purpose',
    sourceUwmField: 'Purpose',
    source: 'uwm',
    label: 'UWM · Purpose',
    description: 'UWM Insights API field Purpose (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_QMTestResult',
    path: 'uwm.QMTestResult',
    sourceUwmField: 'QMTestResult',
    source: 'uwm',
    label: 'UWM · Qm Test Result',
    description: 'UWM Insights API field QMTestResult (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_Receive',
    path: 'uwm.Receive',
    sourceUwmField: 'Receive',
    source: 'uwm',
    label: 'UWM · Receive',
    description: 'UWM Insights API field Receive (Date). Read straight from the raw UWM payload.',
    type: 'date',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_RecordCreatedDateTime',
    path: 'uwm.RecordCreatedDateTime',
    sourceUwmField: 'RecordCreatedDateTime',
    source: 'uwm',
    label: 'UWM · Record Created Date Time',
    description: 'UWM Insights API field RecordCreatedDateTime (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'dates',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_RecordModifiedDateTime',
    path: 'uwm.RecordModifiedDateTime',
    sourceUwmField: 'RecordModifiedDateTime',
    source: 'uwm',
    label: 'UWM · Record Modified Date Time',
    description: 'UWM Insights API field RecordModifiedDateTime (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'dates',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_RefinancePurpose',
    path: 'uwm.RefinancePurpose',
    sourceUwmField: 'RefinancePurpose',
    source: 'uwm',
    label: 'UWM · Refinance Purpose',
    description: 'UWM Insights API field RefinancePurpose (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_ReimbursementAmount',
    path: 'uwm.ReimbursementAmount',
    sourceUwmField: 'ReimbursementAmount',
    source: 'uwm',
    label: 'UWM · Reimbursement Amount',
    description: 'UWM Insights API field ReimbursementAmount (Decimal). Read straight from the raw UWM payload.',
    type: 'number',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_SafeCheck',
    path: 'uwm.SafeCheck',
    sourceUwmField: 'SafeCheck',
    source: 'uwm',
    label: 'UWM · Safe Check',
    description: 'UWM Insights API field SafeCheck (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_SalesPrice',
    path: 'uwm.SalesPrice',
    sourceUwmField: 'SalesPrice',
    source: 'uwm',
    label: 'UWM · Sales Price',
    description: 'UWM Insights API field SalesPrice (Integer). Read straight from the raw UWM payload.',
    type: 'integer',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_SecondaryBorrower1FullName',
    path: 'uwm.SecondaryBorrower1FullName',
    sourceUwmField: 'SecondaryBorrower1FullName',
    source: 'uwm',
    label: 'UWM · Secondary Borrower1 Full Name',
    description: 'UWM Insights API field SecondaryBorrower1FullName (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'borrower',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_SecondaryBorrower2FullName',
    path: 'uwm.SecondaryBorrower2FullName',
    sourceUwmField: 'SecondaryBorrower2FullName',
    source: 'uwm',
    label: 'UWM · Secondary Borrower2 Full Name',
    description: 'UWM Insights API field SecondaryBorrower2FullName (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'borrower',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_SecondaryBorrower3FullName',
    path: 'uwm.SecondaryBorrower3FullName',
    sourceUwmField: 'SecondaryBorrower3FullName',
    source: 'uwm',
    label: 'UWM · Secondary Borrower3 Full Name',
    description: 'UWM Insights API field SecondaryBorrower3FullName (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'borrower',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_SecondaryBorrower4FullName',
    path: 'uwm.SecondaryBorrower4FullName',
    sourceUwmField: 'SecondaryBorrower4FullName',
    source: 'uwm',
    label: 'UWM · Secondary Borrower4 Full Name',
    description: 'UWM Insights API field SecondaryBorrower4FullName (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'borrower',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_SelfEmployed',
    path: 'uwm.SelfEmployed',
    sourceUwmField: 'SelfEmployed',
    source: 'uwm',
    label: 'UWM · Self Employed',
    description: 'UWM Insights API field SelfEmployed (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_SellerRealEstateAddress',
    path: 'uwm.SellerRealEstateAddress',
    sourceUwmField: 'SellerRealEstateAddress',
    source: 'uwm',
    label: 'UWM · Seller Real Estate Address',
    description: 'UWM Insights API field SellerRealEstateAddress (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_SellerRealEstateAgency',
    path: 'uwm.SellerRealEstateAgency',
    sourceUwmField: 'SellerRealEstateAgency',
    source: 'uwm',
    label: 'UWM · Seller Real Estate Agency',
    description: 'UWM Insights API field SellerRealEstateAgency (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_SellerRealEstateAgencyLicense',
    path: 'uwm.SellerRealEstateAgencyLicense',
    sourceUwmField: 'SellerRealEstateAgencyLicense',
    source: 'uwm',
    label: 'UWM · Seller Real Estate Agency License',
    description: 'UWM Insights API field SellerRealEstateAgencyLicense (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_SellerRealEstateAgencyNMLS',
    path: 'uwm.SellerRealEstateAgencyNMLS',
    sourceUwmField: 'SellerRealEstateAgencyNMLS',
    source: 'uwm',
    label: 'UWM · Seller Real Estate Agency NMLS',
    description: 'UWM Insights API field SellerRealEstateAgencyNMLS (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_SellerRealEstateAgentEmail',
    path: 'uwm.SellerRealEstateAgentEmail',
    sourceUwmField: 'SellerRealEstateAgentEmail',
    source: 'uwm',
    label: 'UWM · Seller Real Estate Agent Email',
    description: 'UWM Insights API field SellerRealEstateAgentEmail (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_SellerRealEstateAgentLicense',
    path: 'uwm.SellerRealEstateAgentLicense',
    sourceUwmField: 'SellerRealEstateAgentLicense',
    source: 'uwm',
    label: 'UWM · Seller Real Estate Agent License',
    description: 'UWM Insights API field SellerRealEstateAgentLicense (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_SellerRealEstateAgentName',
    path: 'uwm.SellerRealEstateAgentName',
    sourceUwmField: 'SellerRealEstateAgentName',
    source: 'uwm',
    label: 'UWM · Seller Real Estate Agent Name',
    description: 'UWM Insights API field SellerRealEstateAgentName (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_SellerRealEstateAgentNMLS',
    path: 'uwm.SellerRealEstateAgentNMLS',
    sourceUwmField: 'SellerRealEstateAgentNMLS',
    source: 'uwm',
    label: 'UWM · Seller Real Estate Agent NMLS',
    description: 'UWM Insights API field SellerRealEstateAgentNMLS (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_SellerRealEstateAgentPhone',
    path: 'uwm.SellerRealEstateAgentPhone',
    sourceUwmField: 'SellerRealEstateAgentPhone',
    source: 'uwm',
    label: 'UWM · Seller Real Estate Agent Phone',
    description: 'UWM Insights API field SellerRealEstateAgentPhone (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_SellerRealEstateCity',
    path: 'uwm.SellerRealEstateCity',
    sourceUwmField: 'SellerRealEstateCity',
    source: 'uwm',
    label: 'UWM · Seller Real Estate City',
    description: 'UWM Insights API field SellerRealEstateCity (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_SellerRealEstateState',
    path: 'uwm.SellerRealEstateState',
    sourceUwmField: 'SellerRealEstateState',
    source: 'uwm',
    label: 'UWM · Seller Real Estate State',
    description: 'UWM Insights API field SellerRealEstateState (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_SellerRealEstateZipCode',
    path: 'uwm.SellerRealEstateZipCode',
    sourceUwmField: 'SellerRealEstateZipCode',
    source: 'uwm',
    label: 'UWM · Seller Real Estate Zip Code',
    description: 'UWM Insights API field SellerRealEstateZipCode (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_ServicingSoldDate',
    path: 'uwm.ServicingSoldDate',
    sourceUwmField: 'ServicingSoldDate',
    source: 'uwm',
    label: 'UWM · Servicing Sold Date',
    description: 'UWM Insights API field ServicingSoldDate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'dates',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_SignatureDate_1003',
    path: 'uwm.SignatureDate_1003',
    sourceUwmField: 'SignatureDate_1003',
    source: 'uwm',
    label: 'UWM · Signature Date_1003',
    description: 'UWM Insights API field SignatureDate_1003 (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_SrUWEmailAddress',
    path: 'uwm.SrUWEmailAddress',
    sourceUwmField: 'SrUWEmailAddress',
    source: 'uwm',
    label: 'UWM · Sr UW Email Address',
    description: 'UWM Insights API field SrUWEmailAddress (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'parties',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_SrUWExt',
    path: 'uwm.SrUWExt',
    sourceUwmField: 'SrUWExt',
    source: 'uwm',
    label: 'UWM · Sr UW Ext',
    description: 'UWM Insights API field SrUWExt (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'parties',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_SrUWFirstName',
    path: 'uwm.SrUWFirstName',
    sourceUwmField: 'SrUWFirstName',
    source: 'uwm',
    label: 'UWM · Sr UW First Name',
    description: 'UWM Insights API field SrUWFirstName (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'parties',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_SrUWLastName',
    path: 'uwm.SrUWLastName',
    sourceUwmField: 'SrUWLastName',
    source: 'uwm',
    label: 'UWM · Sr UW Last Name',
    description: 'UWM Insights API field SrUWLastName (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'parties',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_SubmissionDateTime',
    path: 'uwm.SubmissionDateTime',
    sourceUwmField: 'SubmissionDateTime',
    source: 'uwm',
    label: 'UWM · Submission Date Time',
    description: 'UWM Insights API field SubmissionDateTime (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'dates',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_Term',
    path: 'uwm.Term',
    sourceUwmField: 'Term',
    source: 'uwm',
    label: 'UWM · Term',
    description: 'UWM Insights API field Term (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_TitleExpirationDate',
    path: 'uwm.TitleExpirationDate',
    sourceUwmField: 'TitleExpirationDate',
    source: 'uwm',
    label: 'UWM · Title Expiration Date',
    description: 'UWM Insights API field TitleExpirationDate (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_TitleToBeHeldIn',
    path: 'uwm.TitleToBeHeldIn',
    sourceUwmField: 'TitleToBeHeldIn',
    source: 'uwm',
    label: 'UWM · Title To Be Held In',
    description: 'UWM Insights API field TitleToBeHeldIn (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_TLTV',
    path: 'uwm.TLTV',
    sourceUwmField: 'TLTV',
    source: 'uwm',
    label: 'UWM · Tltv',
    description: 'UWM Insights API field TLTV (Decimal). Read straight from the raw UWM payload.',
    type: 'number',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_ToleranceCures',
    path: 'uwm.ToleranceCures',
    sourceUwmField: 'ToleranceCures',
    source: 'uwm',
    label: 'UWM · Tolerance Cures',
    description: 'UWM Insights API field ToleranceCures (Decimal). Read straight from the raw UWM payload.',
    type: 'number',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_TotalLoanAmount',
    path: 'uwm.TotalLoanAmount',
    sourceUwmField: 'TotalLoanAmount',
    source: 'uwm',
    label: 'UWM · Total Loan Amount',
    description: 'UWM Insights API field TotalLoanAmount (Decimal). Read straight from the raw UWM payload.',
    type: 'number',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_UltimateAMDdate',
    path: 'uwm.UltimateAMDdate',
    sourceUwmField: 'UltimateAMDdate',
    source: 'uwm',
    label: 'UWM · Ultimate Am Ddate',
    description: 'UWM Insights API field UltimateAMDdate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'dates',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_UltimateAWCDate',
    path: 'uwm.UltimateAWCDate',
    sourceUwmField: 'UltimateAWCDate',
    source: 'uwm',
    label: 'UWM · Ultimate Awc Date',
    description: 'UWM Insights API field UltimateAWCDate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_UltimateBlinkDate',
    path: 'uwm.UltimateBlinkDate',
    sourceUwmField: 'UltimateBlinkDate',
    source: 'uwm',
    label: 'UWM · Ultimate Blink Date',
    description: 'UWM Insights API field UltimateBlinkDate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'dates',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_UltimateCDDate',
    path: 'uwm.UltimateCDDate',
    sourceUwmField: 'UltimateCDDate',
    source: 'uwm',
    label: 'UWM · Ultimate CD Date',
    description: 'UWM Insights API field UltimateCDDate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'docs',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_UltimateEaseDocsDate',
    path: 'uwm.UltimateEaseDocsDate',
    sourceUwmField: 'UltimateEaseDocsDate',
    source: 'uwm',
    label: 'UWM · Ultimate Ease Docs Date',
    description: 'UWM Insights API field UltimateEaseDocsDate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'dates',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_UltimateOneClickAUSDate',
    path: 'uwm.UltimateOneClickAUSDate',
    sourceUwmField: 'UltimateOneClickAUSDate',
    source: 'uwm',
    label: 'UWM · Ultimate One Click AUS Date',
    description: 'UWM Insights API field UltimateOneClickAUSDate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'dates',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_UltimatePADate',
    path: 'uwm.UltimatePADate',
    sourceUwmField: 'UltimatePADate',
    source: 'uwm',
    label: 'UWM · Ultimate Pa Date',
    description: 'UWM Insights API field UltimatePADate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'dates',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_UltimateTotalPoints',
    path: 'uwm.UltimateTotalPoints',
    sourceUwmField: 'UltimateTotalPoints',
    source: 'uwm',
    label: 'UWM · Ultimate Total Points',
    description: 'UWM Insights API field UltimateTotalPoints (Integer). Read straight from the raw UWM payload.',
    type: 'integer',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_UltimateUtrackDate',
    path: 'uwm.UltimateUtrackDate',
    sourceUwmField: 'UltimateUtrackDate',
    source: 'uwm',
    label: 'UWM · Ultimate Utrack Date',
    description: 'UWM Insights API field UltimateUtrackDate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'dates',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_UltimateVOADate',
    path: 'uwm.UltimateVOADate',
    sourceUwmField: 'UltimateVOADate',
    source: 'uwm',
    label: 'UWM · Ultimate Voa Date',
    description: 'UWM Insights API field UltimateVOADate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'dates',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_UltimateVOIDate',
    path: 'uwm.UltimateVOIDate',
    sourceUwmField: 'UltimateVOIDate',
    source: 'uwm',
    label: 'UWM · Ultimate Voi Date',
    description: 'UWM Insights API field UltimateVOIDate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'dates',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_UW2EmailAddress',
    path: 'uwm.UW2EmailAddress',
    sourceUwmField: 'UW2EmailAddress',
    source: 'uwm',
    label: 'UWM · Uw2 Email Address',
    description: 'UWM Insights API field UW2EmailAddress (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'parties',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_UW2Ext',
    path: 'uwm.UW2Ext',
    sourceUwmField: 'UW2Ext',
    source: 'uwm',
    label: 'UWM · Uw2 Ext',
    description: 'UWM Insights API field UW2Ext (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'parties',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_UW2FirstName',
    path: 'uwm.UW2FirstName',
    sourceUwmField: 'UW2FirstName',
    source: 'uwm',
    label: 'UWM · Uw2 First Name',
    description: 'UWM Insights API field UW2FirstName (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'parties',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_UW2LastName',
    path: 'uwm.UW2LastName',
    sourceUwmField: 'UW2LastName',
    source: 'uwm',
    label: 'UWM · Uw2 Last Name',
    description: 'UWM Insights API field UW2LastName (String). Read straight from the raw UWM payload.',
    type: 'string',
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: '',
    category: 'parties',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_UWDate',
    path: 'uwm.UWDate',
    sourceUwmField: 'UWDate',
    source: 'uwm',
    label: 'UWM · UW Date',
    description: 'UWM Insights API field UWDate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'parties',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_UWMUnderwritingFee',
    path: 'uwm.UWMUnderwritingFee',
    sourceUwmField: 'UWMUnderwritingFee',
    source: 'uwm',
    label: 'UWM · UWM Underwriting Fee',
    description: 'UWM Insights API field UWMUnderwritingFee (Decimal). Read straight from the raw UWM payload.',
    type: 'number',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'parties',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_UWTouches',
    path: 'uwm.UWTouches',
    sourceUwmField: 'UWTouches',
    source: 'uwm',
    label: 'UWM · UW Touches',
    description: 'UWM Insights API field UWTouches (Integer). Read straight from the raw UWM payload.',
    type: 'integer',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'parties',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_VVOEExpDate',
    path: 'uwm.VVOEExpDate',
    sourceUwmField: 'VVOEExpDate',
    source: 'uwm',
    label: 'UWM · Vvoe Exp Date',
    description: 'UWM Insights API field VVOEExpDate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'dates',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_VVOEOrderedDate',
    path: 'uwm.VVOEOrderedDate',
    sourceUwmField: 'VVOEOrderedDate',
    source: 'uwm',
    label: 'UWM · Vvoe Ordered Date',
    description: 'UWM Insights API field VVOEOrderedDate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'dates',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_VVOEReceiveddate',
    path: 'uwm.VVOEReceiveddate',
    sourceUwmField: 'VVOEReceiveddate',
    source: 'uwm',
    label: 'UWM · Vvoe Receiveddate',
    description: 'UWM Insights API field VVOEReceiveddate (DateTime). Read straight from the raw UWM payload.',
    type: 'datetime',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01T00:00:00Z',
    category: 'dates',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_VVOERequired',
    path: 'uwm.VVOERequired',
    sourceUwmField: 'VVOERequired',
    source: 'uwm',
    label: 'UWM · Vvoe Required',
    description: 'UWM Insights API field VVOERequired (Boolean). Read straight from the raw UWM payload.',
    type: 'boolean_yn',
    enumValues: [
      { value: 'Y', label: 'Yes' },
      { value: 'N', label: 'No' },
    ],
    allowedOps: ['eq','neq','exists','not_exists'],
    exampleValue: 'Y',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_WireDate',
    path: 'uwm.WireDate',
    sourceUwmField: 'WireDate',
    source: 'uwm',
    label: 'UWM · Wire Date',
    description: 'UWM Insights API field WireDate (Date). Read straight from the raw UWM payload.',
    type: 'date',
    allowedOps: ['eq','neq','lt','lte','gt','gte','exists','not_exists'],
    exampleValue: '2026-01-01',
    category: 'dates',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_YearAcquired',
    path: 'uwm.YearAcquired',
    sourceUwmField: 'YearAcquired',
    source: 'uwm',
    label: 'UWM · Year Acquired',
    description: 'UWM Insights API field YearAcquired (Integer). Read straight from the raw UWM payload.',
    type: 'integer',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  },
  {
    id: 'uwm_YieldSpreadPremium',
    path: 'uwm.YieldSpreadPremium',
    sourceUwmField: 'YieldSpreadPremium',
    source: 'uwm',
    label: 'UWM · Yield Spread Premium',
    description: 'UWM Insights API field YieldSpreadPremium (Decimal). Read straight from the raw UWM payload.',
    type: 'number',
    allowedOps: ['eq','neq','gt','gte','lt','lte','exists','not_exists'],
    exampleValue: '0',
    category: 'loan',
    note: 'Auto-generated from UWM Insights Onboarding Guide. Only resolves when this field is in the active pull set on the UWM Fields admin page.',
  }
] as const;
